<template>
    <div>
        <img :src="testType" />
    </div>
</template>

<script>
export default {
    mounted() {
        this.checkTestType();
    },
    props: ["data", "onClose"],
    data() {
        return {
            testType: null,
            timeMachine: require("../../assets/img/howitworks/timemachine.png"),
            compareScore: require("../../assets/img/howitworks/comparescore.png"),
            negativeMarking: require("../../assets/img/howitworks/negativemarking.png"),
            // chapterWise: require("../../assets/img/howitworks/negativemarking.png"),
            chapterWise: require("../../assets/img/howitworks/chapterwise.png")
        };
    },
    methods: {
        checkTestType() {
            switch (this.data.image) {
                case this.TESTWISEANALYSIS_TEST_TYPES.TIMEMACHINE:
                    this.testType = this.timeMachine;
                    break;
                case this.TESTWISEANALYSIS_TEST_TYPES.NEGATIVEMARKING:
                    this.testType = this.negativeMarking;
                    break;
                case this.TESTWISEANALYSIS_TEST_TYPES.COMPARESCORE:
                    this.testType = this.compareScore;
                    break;
                case this.TESTWISEANALYSIS_TEST_TYPES.CHAPTERWISEPERFORMANCE:
                    this.testType = this.chapterWise;
                    break;
            }
        }
    },
    watch: {
        "data.image": function(val) {
            this.checkTestType();
        }
    }
};
</script>

<style>
</style>